export default __webpack_public_path__ + "static/media/sunrise_landscapes.23ecf40d.jpg";